import type { ReactNode } from "react";

interface ActionTileProps {
  icon: ReactNode;
  label: string;
  count: number;
  ctaLabel: string;
  onClick: () => void;
}

const ActionTile = ({ icon, label, count, ctaLabel, onClick }: ActionTileProps) => (
  <div className="rounded-[24px] border border-slate-200/80 bg-white/95 p-5 shadow-[0_12px_30px_rgba(15,23,42,0.08)] dark:border-white/10 dark:bg-slate-950/60 dark:shadow-[0_20px_40px_rgba(0,0,0,0.32)]">
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div>
        <p className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300">
          <span className="text-xl text-indigo-500">{icon}</span>
          <span>{label}</span>
        </p>
        <p className="mt-2 text-3xl font-semibold text-slate-900 dark:text-white">{count}</p>
      </div>
      <button
        type="button"
        onClick={onClick}
        className="inline-flex shrink-0 items-center justify-between whitespace-nowrap rounded-full bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-500/25 transition hover:-translate-y-0.5 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 motion-reduce:transform-none md:self-auto self-start"
      >
        {ctaLabel}
        <span className="ml-2 inline-flex items-center justify-center rounded-full bg-white/20 px-2 py-0.5 text-xs font-bold text-white">
          {count}
        </span>
      </button>
    </div>
  </div>
);

export default ActionTile;
